export const DEAL_STATUSES = {
  closed: 'closed',
  draft: 'draft',
  finalized: 'finalized',
  cancelled: 'cancelled',
  refunded: 'refunded',
  unsubscribed: 'unsubscribed',
  ready: 'ready',
}
